import { atom } from 'jotai';
import { MapData_Base } from "~/common/typescript/models/MapData";

export const dataTable_selecetedMapData_Atom = atom<MapData_Base>({
  key: 'dataTable_selecetedMapData_Atom',
  default: undefined,
});